import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20showcase%20flatlay%20with%20curated%20fashion%20items%20sneakers%20hoodies%20bags%20accessories%20arranged%20on%20warm%20cream%20linen%20surface%2C%20soft%20natural%20daylight%20streaming%20from%20window%2C%20editorial%20catalog%20photography%20aesthetic%2C%20neutral%20beige%20and%20warm%20cream%20tones%2C%20organized%20scattered%20layout%2C%20subtle%20shadows%2C%20high%20end%20modern%20ecommerce%20lifestyle%20scene%2C%20sophisticated%20harmonious%20composition&width=1600&height=900&seq=hero-fresh-2026-v3&orientation=landscape"
          alt="Sugargoo Spreadsheet curated product collection with shoes hoodies bags and accessories"
          title="Sugargoo Spreadsheet - Curated Product Collection Database"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium mb-6 whitespace-nowrap">
          Updated Daily Resources &bull; Beginner Friendly &bull; Independent Resource
        </span>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-tight mb-6">
          Sugargoo Spreadsheet 2026 <br className="hidden md:block" />
          The Ultimate Database For Finds & Shopping Guides
        </h1>

        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover thousands of organized Sugargoo Spreadsheet resources including product finds,
          categories, shopping guides, QC information, shipping tips and expert recommendations.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 text-base font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
            <i className="ri-arrow-right-line ml-2 text-lg"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 text-base font-semibold rounded-md bg-background-50 text-foreground-950 hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line ml-2 text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}